import type { GameCardBaseProps } from './types';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import GameCardCover from './components/GameCardCover';
import GameLikeButton from './components/GameLikeButton';

export type { GameCardVariant } from './types';

export type GameCardProps = {
  path: string;
} & GameCardBaseProps;

const GameCard = (props: GameCardProps) => {
  const {
    id,
    path,
    name,
    cover,
    className,
    pictureClassName,
    showName,
    priority,
    variant = 'game-cover-grid',
    children,
    likeButtonPosition = 'default',
    likeButtonIconSize = 'default',
    isFavorited,
  } = props;

  return (
    <div className={cn('flex flex-col transition-transform will-change-transform duration-200 hover:scale-105 transform-gpu py-1 relative', className)}>
      <GameLikeButton
        gameId={id}
        position={likeButtonPosition}
        iconSize={likeButtonIconSize}
        isFavorited={isFavorited}
      />

      <Link
        href={path}
        prefetch={false}
        className="flex flex-col gap-1.75"
      >
        <GameCardCover
          name={name}
          cover={cover}
          priority={priority}
          variant={variant}
          pictureClassName={pictureClassName}
        />

        {showName && <p style={{ perspective: '1px' }} className="will-change-transform subpixel-antialiased text-sm font-semibold capitalize text-light">{name}</p>}
      </Link>
      {children}
    </div>
  );
};

GameCard.displayName = 'GameCard';
export default GameCard;
